import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

    static targets = [
        "permission"
    ]

    connect() {
        const disabledTargetId = `#${this.permissionTarget.value}--dropdown--disabled--value`
        this.disabledTarget = document.querySelector(disabledTargetId)
        this.selectBtn = document.querySelector(`#${this.permissionTarget.value}--dropdown--select-button`);
    }

    checkboxClick(e) {
        this.toggleDropdown(this.disabledTarget)
    }

    toggleDropdown(target) {
        if (target.value == "true") {
            target.value = "false"
        } else {
            target.value = "true"
        }
        this.selectBtn.classList.toggle("bg-gray-200")
    }
}
